import partnersFile from './partners.json'

export interface Partner {
  slug: string
  name: string
  reason: string
  /** Affiliate or marketing URL. When affiliatePlaceholder is true, replace before go-live revenue. */
  destinationUrl: string
  affiliatePlaceholder: boolean
  /** Shown in the visible partner strip (target 4–6). Full list stays in partners.json. */
  featured: boolean
}

export interface PartnersConfig {
  headline: string
  supportLine: string
  /** Shown under the partner cards. Must say these are affiliate links. */
  disclosure: string
  partners: Partner[]
}

export const partnersConfig: PartnersConfig = {
  headline: partnersFile.headline,
  supportLine: partnersFile.supportLine,
  disclosure: partnersFile.disclosure,
  partners: partnersFile.partners,
}

/** Cards shown on download + post-diagnose surfaces. */
export const featuredPartners: Partner[] = partnersConfig.partners.filter((p) => p.featured)

export const partnerPath = (slug: string): string => `/go/${slug}`
